import { render } from "./ReachabilityCard.vue?vue&type=template&id=63b9ca44&scoped=true"
import script from "./ReachabilityCard.vue?vue&type=script&lang=js"
export * from "./ReachabilityCard.vue?vue&type=script&lang=js"

import "./ReachabilityCard.vue?vue&type=style&index=0&id=63b9ca44&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63b9ca44"]])

export default __exports__